import app from './app';
import modules from './modules';
import home from './home';
import user from './user';
import search from './search';
import notifications from './notification';
import bookmarks from './bookmarks';
import eventApproval from './eventApproval';
import events from './events';
import coursedetails from './coursedetails';
import courselist from './courselist';
import dashboard from './dashboard';
import documents from './documents';
import documentsExpert from './documentsExpert';
import liveEvent from './liveEvent';
import news from './news';
import newsletter from './newsletter';
import permissions from './permissions';
import publicSite from './public';
import scorm from './scorm';
import statistics from './statistics';
import tutorCourseList from './tutorCourseList';
import tutors from './tutors';
import utils from './utils';
import supervisorStats from './supervisorStats';

export default {
  app,
  modules,
  home,
  courselist,
  coursedetails,
  eventApproval,
  events,
  user,
  search,
  news,
  documents,
  documentsExpert,
  liveEvent,
  newsletter,
  notifications,
  bookmarks,
  dashboard,
  permissions,
  publicSite,
  scorm,
  statistics,
  tutorCourseList,
  tutors,
  utils,
  supervisorStats,
};
